export default __webpack_public_path__ + "static/media/info_24px.c0297164.svg";